export const featureItems = [
  {
    icon: "ri-bar-chart-2-line",
    title: "Smart Spreadsheet Comparison",
    description: "Compare thousands of fashion items side by side with structured spreadsheet views that make decision-making effortless.",
  },
  {
    icon: "ri-shirt-line",
    title: "Outfit Breakdown Analysis",
    description: "Detailed outfit deconstruction with pricing, brand alternatives, and style matching for every look you love.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Price Tracking Across Categories",
    description: "Real-time price comparison across Shoes, Hoodies, T-Shirts, Jackets, and 10 more fashion categories updated weekly.",
  },
  {
    icon: "ri-brain-line",
    title: "AI Curated Fashion Lists",
    description: "Intelligently organized spreadsheets that filter through noise and surface only the best-value fashion finds.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Fast Updated Trend Database",
    description: "Our fashion spreadsheet library refreshes every week so you never miss emerging streetwear and luxury trends.",
  },
];

export const trustMetrics = [
  { value: "Updated Weekly", label: "Data Freshness" },
  { value: "1,000+", label: "Curated Items" },
  { value: "14", label: "Categories Tracked" },
  { value: "Independent", label: "Fashion Research" },
];